'use client';
import React from 'react';
import { withDefaultValues } from '../withDefaultValues';
export const InfoIcon = withDefaultValues(
  (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4ZM12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5ZM11.0273 9.79785C11.9611 9.73642 12.7287 10.5545 12.6084 11.4824L12.5684 11.6826L11.6357 15.1797C11.5189 15.618 12.0001 15.9729 12.3848 15.7324L14.2354 14.5762C14.4695 14.43 14.7775 14.5012 14.9238 14.7354C15.07 14.9695 14.9988 15.2775 14.7646 15.4238L12.9141 16.5811C11.76 17.3019 10.3193 16.2367 10.6699 14.9219L11.6025 11.4248L11.6162 11.3584C11.6565 11.049 11.4002 10.7764 11.0889 10.7969L11.0215 10.8057L10.0977 10.9902C9.82701 11.0442 9.5639 10.8683 9.50977 10.5977C9.45585 10.327 9.63169 10.0639 9.90234 10.0098L10.8252 9.8252L11.0273 9.79785ZM12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7Z"
        fill="#7A8B94"
      />
    </svg>
  )
);
